/**
 * Утилита валидации email-адреса
 *
 * Проверяет соответствие строки базовому формату email.
 * Используется в AuthPage, EmailBindDialog и других формах ввода email.
 */

// Regex-паттерн для валидации email
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/**
 * Проверяет корректность email-адреса по regex-паттерну
 *
 * @param {string} email - Строка для проверки
 * @returns {boolean} true если email соответствует формату
 */
export const validateEmail = (email: string): boolean => {
  return EMAIL_REGEX.test(email)
}
